import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-04d5472a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal is-active",
  ref: "about"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-background" }, null, -1))
const _hoisted_3 = { class: "modal-card" }
const _hoisted_4 = { class: "modal-card-head" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "modal-card-body" }
const _hoisted_7 = {
  key: 0,
  class: "app-logo mb-4"
}
const _hoisted_8 = ["src"]
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("footer", { class: "modal-card-foot custom-modal-card-foot is-justify-content-flex-end" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("header", _hoisted_4, [
        _createElementVNode("p", {
          class: "modal-card-title is-title-shrink",
          innerHTML: _ctx.modalTitleText
        }, null, 8, _hoisted_5),
        _createElementVNode("button", {
          class: "delete",
          "aria-label": "close",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$modal.close()))
        })
      ]),
      _createElementVNode("section", _hoisted_6, [
        _createElementVNode("div", null, [
          (_ctx.$config.logoUrl)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("img", {
                  class: "app-img",
                  src: _ctx.$config.logoUrl
                }, null, 8, _hoisted_8)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: "app-version mb-3",
            innerHTML: _ctx.versionHtml
          }, null, 8, _hoisted_9),
          _createElementVNode("p", {
            class: "app-description",
            align: "justify",
            innerHTML: _ctx.modalHtml
          }, null, 8, _hoisted_10)
        ])
      ]),
      _hoisted_11
    ])
  ], 512))
}